/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'jquery-match-height';
import 'slick-carousel';
import cookies from 'js-cookie/src/js.cookie';
import 'simplelightbox';

$(document).ready(() => {
  $('.preserve-height').matchHeight();

  $('body').on('click', '.language-selector-active', function () {
    var ul = $(this).parents('.language-selector').find('ul');

    if (ul.is(':visible')) {
      $('.language-selector-active').removeClass('active');
      ul.hide();
    } else {
      $('.language-selector-active').addClass('active');
      ul.css('display', 'flex');
    }
  });

  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();

    if (scroll > 1) {
      $('header').addClass('fixed');
    } else {
      $('header').removeClass('fixed');
    }
  });

  $('.menu-selector').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('nav ul.menu').removeClass('active');
    } else {
      $(this).addClass('active');
      $('nav ul.menu').addClass('active');
    }
  });

  $('.language-selector').clone().appendTo('nav ul.menu');

  $('.hp-projects-map input[type="checkbox"]').on('change', function () {
    if (!$(this).prop('checked')) {
      $(this).prop('checked', true);
    } else {
      $('.hp-projects-map input[type="checkbox"]').not(this).prop('checked', false);
    }
  });

  $('.hp-projects__projectlist').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    rows: 1,
    appendArrows: $('.hp-projects-arrows'),
    nextArrow: '<button type="button" class="slick-next"></button>',
    prevArrow: '<button type="button" class="slick-prev"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 0,
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          rows: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  });

  $('.marker').on('click', function () {
    $('html, body').animate({
      scrollTop: $('.hp-projects').offset().top - 310
    }, 1000);
  });

  $('.projects-checkbox').on('change', function () {
    var active = $(this).prop('value');

    $('.projects__projectlist-ind').removeClass('active');
    $('.hp-projects-map .europe, .hp-projects-map .slovakia, .hp-projects-map .tenerife').hide();
    $('.hp-projects-map .' + active).show();

    $('.hp-projects__projectlist').slick('slickUnfilter');

    if (active === 'europe') {} else {
      $('.hp-projects__projectlist').slick(
        'slickFilter',
        function () {
          return $('.slide-' + active + '', this).length === 1;
        }
      );
    }
  });

  var $slick_slider = $('.project-gallery-wrapper__slick');
  var settings_slider = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    appendArrows: $('.hp-projects-arrows'),
    nextArrow: '<button type="button" class="slick-next"></button>',
    prevArrow: '<button type="button" class="slick-prev"></button>',
  }
  slickOnMobile($slick_slider, settings_slider);

  function slickOnMobile(slider, settings) {
    $(window).on('load resize', function () {
      if ($(window).width() > 767) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return;
      }

      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  }

  if (!cookies.get('consent-agree')) {
    $('.cookie-consent').addClass('active');
  }

  $('body').on('click', '.accept-cookie', function (e) {
    e.preventDefault();
    $('.cookie-consent').removeClass('active');
    cookies.set('consent-agree', '1');
  });

  if ($('.project-gallery-wrapper').length) {
    $('.project-gallery-wrapper a').simpleLightbox();
  }

  document.addEventListener('wpcf7mailsent', function () {
    $('.full-width-overlay, .form-success-message').fadeIn();
  }, false);

  $('body').on('click', '.close-success-message', function (e) {
    e.preventDefault();

    $('.full-width-overlay, .form-success-message').fadeOut();
  });

  $('.page-template-template-home .scrollTo a, .smooth-scroll').click(function (e) {
    e.preventDefault();

    var divID = $(this).attr('href').replace('/en/', '').replace('/cz/', '').replace('/', '');
    $('html, body').animate({
      scrollTop: $(divID).offset().top
    }, 1000);

    $('.menu-selector').removeClass('active');
    $('nav ul.menu').removeClass('active');
  });

  $('.europe .marker-bratislava').on('click', function() {
      $('.projects__projectlist-ind').removeClass('active');
      $('.slide-slovakia .projects__projectlist-ind').addClass('active');
  });

  $('.marker-tenerife, .marker-serenity').on('click', function() {
    $('.projects__projectlist-ind').removeClass('active');
    $('.slide-tenerife .projects__projectlist-ind').addClass('active');
  });

  $('.slovakia .marker-bratislava').on('click', function() {
    $('.projects__projectlist-ind').removeClass('active');
    $('.slide-discovery-residence .projects__projectlist-ind').addClass('active');
  });

  $('.slovakia .marker-dubravka').on('click', function() {
    $('.projects__projectlist-ind').removeClass('active');
    $('.slide-dubravia .projects__projectlist-ind').addClass('active');
  });
});
